<template>
    <div class="mb-3" @click="$emit('click')">
        <div class="d-flex justify-content-end text-muted">
            <small class="text-small">{{$moment.utc(date).fromNow()}}</small>
        </div>

        <div class="d-flex border-radius cursor-pointer shadow-sm position-relative" :class="cardClass">
            <div class="flex-shrink-0 pt-3" :class="paddingLeft">
                <div class="p-1 rounded" :class="iconClass">
                    <component width="2em" height="2em" :is="icon"></component>
                </div>
            </div>

            <div class="flex-grow-1">
                <div class="d-flex pt-3 pb-2 px-3 align-items-center">
                    <small class="flex-1 font-weight-bolder d-block align-text-start">
                        {{summary}}
                    </small>
                </div>

                <div class="d-flex">
                    <div class="border-white py-2 flex-1" :class="[rtl, paddingLeft, paddingRight]">
                        <small class="d-flex font-weight-bold">
                            <span><i-tube-no-bg></i-tube-no-bg> {{t('Lab name')}}</span>
                        </small>

                        <small class="d-flex">
                            {{lab_name}}
                        </small>
                    </div>

                    <div class="py-2 flex-1" :class="[paddingLeft, paddingRight]">
                        <small class="d-flex font-weight-bold">
                            <span><i-doctor></i-doctor> {{t('Doctor name')}}</span>
                        </small>

                        <small class="d-flex">
                            {{doctor_name}}
                        </small>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="py-2 flex-1" :class="[paddingLeft, paddingRight]">
                        <small class="d-flex font-weight-bold">
                            <span><i-test-bg-white></i-test-bg-white> {{t('Test name')}}</span>
                        </small>

                        <small class="d-flex align-text-start" v-for="test in tests">
                            - {{test[nameKey] }}
                        </small>
                    </div>
                </div>
            </div>

            <div :class="back"
                 class="flex-shrink-0 position-absolute bg-some-other-skyler-variation rounded p-1 d-flex align-items-center mt-5"
                 v-if="show">
                <i-arrow width=".8em" height=".8em"></i-arrow>
            </div>
        </div>
    </div>
</template>

<script>
    import IDoctor from "../Icons/IDoctor";
    import ITestBgWhite from "../Icons/ITestBgWhite";
    import ITubeNoBg from "../Icons/ITubeNoBg";
    import IRadiologyNoBg from "../Icons/IRadiologyNoBg";
    import ITestTubePink from "../Icons/ITestTubePink";
    import IArrow from "../Icons/IArrow";

    export default {
        name: "TestCard",
        components: {
            IDoctor, ITestBgWhite, ITubeNoBg, IRadiologyNoBg, ITestTubePink, IArrow
        },
        computed: {
            rtl() {
                return this.$translate.lang === 'en' ? 'border-right' : 'border-left';
            },

            paddingLeft() {
                return this.$translate.lang === 'en' ? 'pl-3' : 'pr-3'
            },

            paddingRight() {
                return this.$translate.lang === 'en' ? 'pr-2' : 'pl-2';
            },

            back() {
                return this.$translate.lang === 'en' ? 'back' : 'back-rtl'
            },

            nameKey() {
                return `name_${this.$translate.lang}`
            }
        },
        props: {
            summary: {
                type: String,
                required: true
            },
            show: {
                type: Boolean,
                required: true
            },
            date: {
                type: [String, Date],
                required: true
            },
            doctor_name: {
                type: String,
                required: true
            },
            lab_name: {
                type: String,
                required: true
            },
            tests: {
                type: Array,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
            iconClass: {
                type: String,
                required: true
            },
            cardClass: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
    .back {
        right: -.5em;
    }

    .back-rtl {
        left: -.5em;
    }
</style>
